import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class BudgetType extends Mappeable {

    idTypeStatusBudgetPk: number;
    txtTypeStatusBudget: string;
    mrkActive: boolean;
    orden: number;
    imputable: boolean;

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
    }

    public mapToBack() {
        return {
            txtTypeStatusBudget: this.txtTypeStatusBudget,
            mrkActive: this.mrkActive
        }
    }

}
